import styles from './noResultsMessage.module.scss';

export const NoResultsMessage = () => {
  return <h2 className={styles.message}>No results found ...</h2>;
};
